import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Input } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';
import * as cp_action from 'actions/company';

const propTypes = {};

const defaultProps = {};

class Position extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { input, label, value, onChange } = this.props;

    return (
      <Form.Field inline className="com-position">
        <label style={label}>직위</label>
        <Input className="authority" placeholder="직위" value={value || ''} onChange={onChange} style={input} />
      </Form.Field>
    );
  }
}

Position.propTypes = propTypes;
Position.defaultProps = defaultProps;

Position = connect(
  (state) => ({
    positionList: state.company.position,
    positionName: state.commons.position
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        positionChange: cm_action.ReduxDataSet
      },
      dispatch
    ),
    cpAPI: bindActionCreators(
      {
        positionSel: cp_action.PositionSel
      },
      dispatch
    )
  })
)(Position);

export default Position;
